import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { IndustryReferralsDashboardTableWidgetFilters } from "../widget-filters/IndustryReferralsDashboardTableWidgetFilters";
import { TableWidget } from "./TableWidget";

export class IndustryReferralsDashboardTableWidget extends TableWidget {
    static getWidgetDashboardType() {
        return "Table";
    }

    static getWidgetMetadataType() {
        return "IndustryReferralsDashboardTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getFiltersComponent() {
        return IndustryReferralsDashboardTableWidgetFilters;
    }

    constructor() {
        super();
    }

    public getSearchKey() {
        return "Domain";
    }

    getProperties() {
        const props = super.getProperties();
        return props;
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }
}
IndustryReferralsDashboardTableWidget.register();
